import { Card } from "react-bootstrap";
import profileImg from "../assets/profile.jpeg";

export default function Gallery() {
    return (
        <>
        <b>COMING SOON!</b>
            {/* <Card style={{ width: '80rem' }}>
                <Card.Body>
                    <Card.Title>Gallery</Card.Title>
                    <Card.Text>
                        <div className="d-flex justify-content-evenly flex-wrap">
                            COMING SOON!
                        
                        </div>

                    </Card.Text>
                </Card.Body>
            </Card>         */}
        </>
    );
}